import { render, staticRenderFns } from "./DtDormitoryRoomInfo.vue?vue&type=template&id=108d6827&"
import script from "./DtDormitoryRoomInfo.vue?vue&type=script&lang=js&"
export * from "./DtDormitoryRoomInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports